module.exports = __webpack_public_path__ + "img/product2_l.3d97d37c.jpg";